import React, { Component } from 'react'
import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import queryString from 'query-string'

export default class ProfileComplete extends Component {
  constructor(props) {
    super(props)
    this.props.updateActivePage(null)
    const code = queryString.parse(this.props.location.search)
    this.props.processProfile(code)
    document.title = "Profile Complete"
  }
  
  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div id="profile_complete">
        <AriaMessage message="Navigated to completed personal profile page" />
        <Title>Thank You For Choosing Newtopia</Title>
        <div className="container personal-complete-container">
          <h2>
            Great news!
            <br/>
            You are registered.
          </h2>
          <p className="personal-complete-ol">
            Need to book a coaching session or have a question?
            <br/>
            We're here to help. Please contact Client Care for assistance.
            <br/>
            Our Care Team will contact you if additional information is needed.
          </p>
        </div>
      </div>
    )
  }
}